import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesServicesReturnMain } from './modules/ui/Main';

const ServicesReturnPage = (
  <SuspensePage>
    <PagesServicesReturnMain />
  </SuspensePage>
);

export default ServicesReturnPage;
